import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getLogsByIdyAction = createAsyncThunk(
    'get-logs',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/my-activity-logs`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getLogsByIdySlice = createSlice({
    name: 'get-logs',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getLogsByIdyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getLogsByIdyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getLogsByIdyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getLogsByIdyReducer = getLogsByIdySlice.reducer    